import { useEffect } from 'react'
import {
  Typography,
  Button,
  Card,
  CardContent,
  CardActions,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
  Divider,
  CircularProgress,
  Box,
} from '@mui/material'
import { useSessionContext } from '../../providers'

export const SessionManager = () => {
  const { sessions, sessionLoading, fetchSessions, setCookie } =
    useSessionContext()

  useEffect(() => {
    fetchSessions()
  }, [])

  return (
    <Card variant="outlined">
      <CardContent>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 1,
          }}
        >
          <Typography variant="h6" gutterBottom>
            Oturum Yönetimi
          </Typography>
          {sessionLoading && <CircularProgress />}
        </Box>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          Kullanmak istediğiniz oturuma tıklayın
        </Typography>

        {sessions.length === 0 ? (
          <Typography
            variant="body2"
            color="text.secondary"
            sx={{ textAlign: 'center', py: 2 }}
          >
            Henüz kayıtlı oturum bulunamadı
          </Typography>
        ) : (
          <List
            sx={{
              maxHeight: 300,
              overflow: 'auto',
              border: '1px solid #e0e0e0',
              borderRadius: 1,
              p: 1,
            }}
          >
            {sessions.map((session, index) => (
              <div key={session.id || index}>
                <ListItem disablePadding>
                  <ListItemButton
                    onClick={async () => {
                      if (!session.id) return
                      await setCookie(session.id)
                      window.open('/', '_blank')
                    }}
                    disabled={sessionLoading}
                    sx={{
                      '&:hover': {
                        backgroundColor: 'action.hover',
                      },
                    }}
                  >
                    <ListItemText
                      primary={session.title || 'Oturum'}
                      secondary={
                        session.createdAt
                          ? new Date(session.createdAt).toLocaleString('tr-TR')
                          : undefined
                      }
                    />
                  </ListItemButton>
                </ListItem>
                {index < sessions.length - 1 && <Divider />}
              </div>
            ))}
          </List>
        )}
      </CardContent>
      <CardActions>
        <Button onClick={fetchSessions} disabled={sessionLoading}>
          Yenile
        </Button>
      </CardActions>
    </Card>
  )
}
